
import {  inISC  } from '@act-lib/js-bridge';
const setStateBarColor = (fontColor, stateColor) => {
    if(inISC) {
        window.ISCbridge.setStateBarColor({
            fontColor: fontColor,
            stateColor: stateColor,
            fullScreen: 0,
            showTitle: 0
        }); 
    }
};

export default setStateBarColor;